import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnoozeIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/snooze-incident-dialog/snooze-incident-dialog.component';
import { VerifyIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/verify-incident-dialog/verify-incident-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-cricital-incidents',
  templateUrl: './cricital-incidents.component.html',
  styleUrls: ['./cricital-incidents.component.scss'],
})
export class CricitalIncidentsComponent {
  @Output() showIncidentDetail = new EventEmitter<any>();
  @Output() verifyIncident = new EventEmitter<any>();
  @Output() snoozeIncident = new EventEmitter<any>();

  @Input() set incidentTableData(val: IIncidents[]) {
    // this.temp = val.filter(
    //   (incident) =>
    //     incident.incidentName == 'Intrusion' ||
    //     incident.incidentName == 'Fire' ||
    //     incident.incidentName == 'Advanced SOS' ||
    //     incident.incidentCriticality == 'High'
    // );
    this.temp = val;
    this.filtered = val;
    this.filteredDataSource = new MatTableDataSource(this.temp);
    this.expandedDetail = '';
  }
  @Input() set isIncidentDetailsClosed(val: boolean) {
    if (!val) {
      this.isShowDetails = false;
      this.expandedDetail = '';
    }
  }
  isUserDashboard = false;
  displayedColumns = ['name', 'date', 'time', 'asset', 'action', 'Details'];
  temp: IIncidents[];
  screenSize: ScreenType;
  ScreenType = ScreenType;
  filtered: IIncidents[] = [];
  filteredDataSource: MatTableDataSource<IIncidents>;
  isShowDetails = false;
  expandedDetail = '';
  constructor(
    private dialog: MatDialog,
    private encryptionService: EncryptionService,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  onShowDetails(val: any) {
    this.isShowDetails = true;
    this.expandedDetail = val.incidentId;
    this.showIncidentDetail.emit(val);
  }
  getFormatedDate(val: any) {
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
  onClickStatus(val: any) {
    const dialogRef = this.dialog.open(VerifyIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: string) => {
      let data = {
        status:
          result == 'Open'
            ? '0'
            : result == 'Close'
            ? '1'
            : result == 'Verified'
            ? '2'
            : result == 'Snooze'
            ? '3'
            : result == 'In-Progress'
            ? '4'
            : result == 'On-Hold'
            ? '5'
            : result == 'Approved'
            ? '6'
            : result == 'Rejected'
            ? '7'
            : result == 'Completed'
            ? '8'
            : '',
        incidentId: val.incidentId,
      };
      if (data.status == '3') {
        const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
          disableClose: true,
          data: val,
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          let data = {
            isSnooze: true,
            durationType: result.durationType,
            durationSize: result.durationSize,
            incidentId: val.incidentId,
            status: '3',
          };
          if (result) {
            this.verifyIncident.emit(data);
          }
        });
      } else {
        if (result) {
          this.verifyIncident.emit(data);
        }
      }
    });
  }
  onVerifyIncident(val: any) {}
  onSnoozeIncident(val: IIncidents) {
    const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    let decryptedUserData = this.encryptionService.decrypt(
      localStorage.getItem('UserDetails')
    );
    dialogRef.afterClosed().subscribe((result: any) => {
      let data = {
        isSnooze: true,
        durationType: result.durationType,
        durationSize: result.durationSize,
        incidentId: val.incidentId,
        orgId: val.orgId,
        incidenType: val.incidentType,
        incidentName: val.incidentName,
        incidentStatusTimeline: val.incidentStatusTimeline,
        assignedBy:
          decryptedUserData.FirstName + ' ' + decryptedUserData.LastName,
        assignedById: decryptedUserData.UserID,
        createBy: val.eventCreatedBy,
        createById: val.eventCreatedByUserID,
        assignedTo: val.assignedTo,
        assignedToUserId: val.assignedToUserId,
        evidence: val.eventEvidence,
      };
      if (result) {
        this.snoozeIncident.emit(data);
      }
    });
  }
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredDataSource.filter = filterValue.trim().toLowerCase();
    if (this.filteredDataSource.paginator) {
      this.filteredDataSource.paginator.firstPage();
    }
    // Filter the temp array
    this.filtered = this.temp.filter((incident: IIncidents) => {
      const incidentNameMatch = incident.incidentName
        .trim()
        .toLowerCase()
        .includes(filterValue);
      const incidentIdMatch = incident.incidentId
        .toString()
        .includes(filterValue); // Assuming visitorId is a number
      const incidentStatusMatch = incident.incidentStatus
        .toString()
        .includes(filterValue); // Assuming securityStatus is a number
      const assigneeMatch = incident.assignedTo
        .toString()
        .includes(filterValue);

      const reporterMatch = incident.eventCreatedBy
        .toString()
        .includes(filterValue);

      return (
        incidentIdMatch ||
        incidentStatusMatch ||
        incidentNameMatch ||
        reporterMatch ||
        assigneeMatch
      );
    });
  }
  selectedStatus = '-1';
  onChangeDataTable(event: any) {
    this.selectedStatus = event.value;
    const selectedStatus = +event.value; // Convert to number
    if (selectedStatus === -1) {
      // Show all incidents
      this.filteredDataSource.data = this.temp;
    } else {
      // Filter based on incidentStatus
      this.filteredDataSource.data = this.temp.filter(
        (incident: IIncidents) => incident.incidentStatus === selectedStatus
      );
    }
  }
}
